import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const openSocial = (url) => {
    window.open(url, '_blank', 'noopener noreferrer');
  };

  return (
    <>
      <style>{`
        .footer {
          background-color: #1A1A1A;
          color: #FFFFFF;
          padding: 5rem 5% 2rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          position: relative;
          overflow: hidden;
        }

        /* Patrón sutil de fondo opcional */
        .footer::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background-image: radial-gradient(#8B4513 1px, transparent 1px);
          background-size: 30px 30px;
          opacity: 0.03;
          pointer-events: none;
        }

        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 3rem;
          margin-bottom: 4rem;
          position: relative;
          z-index: 1;
        }

        .footer-logo {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .footer-logo-img {
          width: 90px;
          height: 90px;
          object-fit: cover;
          border-radius: 50%;
          border: 3px solid #8B4513;
          padding: 3px;
          background-color: #FFFFFF;
        }

        .footer-logo h3 {
          font-family: 'Playfair Display', serif;
          font-size: 1.5rem;
          color: #D2B48C;
          margin: 0;
          line-height: 1.2;
        }

        .footer-logo p {
          color: #8B4513;
          text-transform: uppercase;
          font-size: 0.85rem;
          letter-spacing: 2px;
          font-weight: 700;
          margin: 0;
        }

        .footer-description {
          color: #A0A0A0;
          line-height: 1.8;
          font-size: 0.95rem;
        }

        .footer-section h4 {
          font-family: 'Playfair Display', serif;
          font-size: 1.3rem;
          margin-bottom: 1.5rem;
          color: #FFFFFF;
          position: relative;
          padding-bottom: 0.8rem;
          display: inline-block;
        }

        .footer-section h4::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 2px;
          background-color: #8B4513;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .footer-links li a {
          color: #CCCCCC;
          text-decoration: none;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.8rem;
          font-size: 0.95rem;
        }

        .footer-links li a span {
          color: #8B4513;
          font-size: 1.2rem;
          transition: transform 0.3s ease;
        }

        .footer-links li a:hover {
          color: #D2B48C;
        }

        .footer-links li a:hover span {
          transform: translateX(5px);
        }

        .footer-contact {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .footer-contact li {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          color: #A0A0A0;
          font-size: 0.95rem;
          line-height: 1.6;
        }

        .footer-contact li span {
          font-size: 1.3rem;
          margin-top: 2px;
        }

        .footer-contact li strong {
          color: #FFFFFF;
          font-weight: 600;
          display: block;
          margin-bottom: 0.2rem;
        }

        .footer-social {
          display: flex;
          gap: 1rem;
          margin-top: 2rem;
        }

        .social-icon {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          width: 45px;
          height: 45px;
          border-radius: 50%;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-size: 1.2rem;
        }

        .social-icon:hover {
          background: #8B4513;
          border-color: #8B4513;
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(139, 69, 19, 0.3);
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 2rem;
          text-align: center;
          position: relative;
          z-index: 1;
        }

        .footer-bottom p {
          color: #888888;
          font-size: 0.9rem;
          margin: 0.5rem 0;
        }

        .footer-bottom span {
          display: inline-block;
          margin: 0 4px;
        }

        @media (max-width: 1024px) {
          .footer-container {
            grid-template-columns: repeat(2, 1fr);
            gap: 3rem;
          }
        }

        @media (max-width: 768px) {
          .footer {
            padding: 4rem 5% 2rem;
          }
          .footer-container {
            grid-template-columns: 1fr;
            gap: 2.5rem;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=150&q=80" alt="Román Valderrábano El Catador" className="footer-logo-img" />
              <h3>Román Valderrábano<br/>El Catador</h3>
              <p>Tradición Familiar</p>
            </div>
            <p className="footer-description">
              Desde 1880 cultivando los mejores granos de café con tradición y pasión. 
              Cocina en barro ancestral que intensifica los sabores en la Sierra Norte de Puebla.
            </p>
          </div>

          <div className="footer-section">
            <h4>Enlaces Rápidos</h4>
            <ul className="footer-links">
              <li><Link to="/products"><span>→</span> Tienda en línea</Link></li>
              <li><Link to="/restaurante"><span>→</span> Cocina de Humo</Link></li>
              <li><Link to="/tours"><span>→</span> Tours Cafetaleros</Link></li>
              <li><Link to="/venta-tonelada"><span>→</span> Venta por Tonelada</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Categorías</h4>
            <ul className="footer-links">
              <li><Link to="/products?categoria=grano"><span>→</span> Café en Grano</Link></li>
              <li><Link to="/products?categoria=molido"><span>→</span> Café Molido</Link></li>
              <li><Link to="/products?categoria=licor"><span>→</span> Licor de Café</Link></li>
              <li><Link to="/products?categoria=galletas"><span>→</span> Galletas Artesanales</Link></li>
              <li><Link to="/products?categoria=bombones"><span>→</span> Bombones</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contacto</h4>
            <ul className="footer-contact">
              <li>
                <span>📍</span>
                <div>
                  <strong>Matriz Xicotepec</strong>
                  Zaragoza 146, Col Centro<br />
                  Xicotepec de Juárez, Puebla<br />
                  C.P. 73080
                </div>
              </li>
              <li>
                <span>📞</span>
                <div>
                  <strong>Teléfono / WhatsApp</strong>
                  +52 1 764 105 7461
                </div>
              </li>
              <li>
                <span>✉️</span>
                <div>
                  <strong>Email Corporativo</strong>
                  romanvalderrabanoelcatador@gmail.com
                </div>
              </li>
              <li>
                <span>⏰</span>
                <div>
                  <strong>Horario de Atención</strong>
                  Lun-Sáb: 8:00 am - 6:00 pm<br />
                </div>
              </li>
            </ul>

            <div className="footer-social">
              <button className="social-icon" aria-label="Facebook" onClick={() => openSocial('https://facebook.com')}>f</button>
              <button className="social-icon" aria-label="Instagram" onClick={() => openSocial('https://instagram.com')}>ig</button>
              <button className="social-icon" aria-label="Twitter" onClick={() => openSocial('https://twitter.com')}>𝕏</button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Román Valderrábano El Catador. Todos los derechos reservados.</p>
          <p>Hecho con <span>❤️</span> y <span>☕</span> en la Sierra Norte de Puebla</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;